<template>
  <vs-popup
    class="holamundo"
    :title="title"
    :active.sync="addNewDataLocal"
    @vs-close="closeForm">
    <p>
      Add notes related to the alert by providing a detailed explanation in text
      and attaching pictures to provide context and clarity.
    </p>
    <form class="mt-5">
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Notes<sup>*</sup></label>
        <div>
          <vs-textarea
            v-model="notes"
            rows="5"
            style="border: 1px solid rgba(0, 0, 0, 0.2)"
            :disabled="!this.is_editable" />
        </div>
        <span></span>
      </div>

      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <label class="vs-input--label">Pictures<sup>*</sup></label>
        <br />
        <div v-if="dataEdit.attachment">
          <template
            v-if="
              Array.isArray(dataEdit.attachment) && dataEdit.attachment.length
            ">
            <img
              v-for="(attachment, index) in dataEdit.attachment"
              :key="index"
              class="cursor-pointer mr-2"
              height="150px"
              :src="attachment"
              @click="onClickImage(attachment)"
              alt="Uploaded Image" />
          </template>
          <template v-else>
            <img
              v-if="dataEdit.attachment"
              class="cursor-pointer mr-2"
              height="150px"
              :src="dataEdit.attachment"
              @click="onClickImage(dataEdit.attachment)"
              alt="Uploaded Image" />
          </template>
        </div>
        <div
          :class="!this.is_editable ? 'hidden' : 'flex flex-col-reverse'"
          style="gap: 10px; flex-wrap: wrap">
          <div class="fileUpload rounded-lg flex" v-if="images.length < 3">
            <input
              type="file"
              class="upload"
              @change="handlePictureChange"
              :key="fileUploadKey"
              multiple
              accept="image/*" />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M4.5551 16.5556C2.60745 16.5556 1.02856 15.2273 1.02856 13.2796C1.02856 11.332 2.60745 9.75307 4.5551 9.75307C4.68754 9.75307 4.81828 9.76038 4.94693 9.7746V9.75307H4.99544C4.96342 9.49635 4.94693 9.2348 4.94693 8.9694C4.94693 5.50691 7.75383 2.70001 11.2163 2.70001C13.561 2.70001 15.6051 3.98715 16.6805 5.89339C16.9433 5.85473 17.2122 5.83471 17.4857 5.83471C20.5154 5.83471 22.9714 8.29074 22.9714 11.3204C22.9714 13.8144 21.3071 15.7156 19.0286 16.3423M11.8269 21.3V12.3M11.8269 12.3L8.22856 16.0117M11.8269 12.3L15.4286 16.0117"
                stroke="#828282"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span class="ml-2">Upload Picture</span>
          </div>
          <div class="flex flex-row" style="gap: 15px">
            <div
              v-for="(image, index) in images"
              :key="index"
              class="mr-2 flex flex-col"
              style="width: fit-content">
              <img
                :src="imageUrl(image)"
                height="150px"
                alt="Uploaded Image"
                class="cursor-pointer"
                @click="onClickImage(imageUrl(image))" />
              <vs-button
                color="danger"
                type="border"
                size="small"
                @click="removeImage(index)">
                Remove
              </vs-button>
            </div>
          </div>
        </div>
        <p class="text-xs mt-3 ml-2">
          *Only accepts image files (.jpg, .jpeg, .png)
        </p>
        <span></span>
      </div>
    </form>
    <vs-divider />
    <div class="vx-row">
      <div class="vx-col">
        <vs-button color="warning" type="border" class="mb-0" @click="closeForm"
          >Cancel</vs-button
        >
      </div>
      <vs-button
        v-if="this.is_editable"
        color="danger"
        type="filled"
        class="mb-0 btn-submit"
        @click="submitsForm"
        :disabled="notes === '' || images.length === 0">
        Submit
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'
import * as moment from 'moment'
import imageCompression from 'browser-image-compression'

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    id: String,
    imei: String,
    title: String,
    editMode: Boolean,
    dataEdit: Object,
  },
  mounted() {
    //
  },
  watch: {
    async editMode(val) {
      this.clearFields()
      if (
        this.dataEdit.verified_by.name != null &&
        this.dataEdit.verified_by.name != ''
      ) {
        this.notes = this.dataEdit.note
        if (Array.isArray(this.dataEdit.attachment)) {
          this.dataEdit.attachment.map(async (attachment) => {
            try {
              const res = await fetch(attachment)
              const blob = await res.blob()
              const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
              this.images.push(file)
            } catch (error) {
              console.error('Error fetching or processing attachment:', error)
            }
          })
        } else if (this.dataEdit.attachment) {
          try {
            const res = await fetch(this.dataEdit.attachment)
            const blob = await res.blob()
            const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
            this.images.push(file)
          } catch (error) {
            console.error('Error fetching or processing attachment:', error)
          }
        }
        // this.images = this.dataEdit.attachment || []
        this.is_editable = false
      }
    },
    // images(val) {
    //
    // },
  },
  computed: {
    addNewDataLocal: {
      get() {
        return JSON.parse(this.isOpen)
      },
      set(val) {
        this.closeForm()
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo !== ''
    },
  },
  data() {
    return {
      parent_array: [],
      is_editable: true,
      notes: '',
      images: [],
      fileUploadKey: 0,
    }
  },
  methods: {
    imageUrl(image) {
      return URL.createObjectURL(image)
    },
    onClickImage(attachment) {
      window.open(attachment, '_blank')
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.notes = ''
      this.images = []
      this.fileUploadKey++
      this.is_editable = true
    },
    handlePictureChange(e) {
      const selectedFiles = Array.from(e.target.files)
      if (this.images.length + selectedFiles.length <= 3) {
        this.images.push(...selectedFiles)
      } else {
        alert('You can only upload a maximum of 3 images.')
      }
    },
    removeImage(index) {
      this.images.splice(index, 1)
    },
    successUpload() {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Files uploaded successfully',
      })
    },
    async submitsForm() {
      // this.loadingBtnStart('btn-submit')
      const param = {
        vehicle_id: this.dataEdit.vehicle_id,
        event_type: this.dataEdit.event_type,
      }
      let dataForm = {
        dir: 'alert_summary' + '/' + this.dataEdit.license_plate,
        note: this.notes,
        verified_date: moment().format('YYYY-MM-DD HH:mm'),
        verified_by: JSON.parse(localStorage.getItem('userInfo')).name,
        start_date: moment(this.dataEdit.start_date).format('YYYY-MM-DD'),
        end_date: moment(this.dataEdit.end_date).format('YYYY-MM-DD'),
      }

      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        }
        const uploadPromises = this.images.map(async (image, index) => {
          const compressedFile = await imageCompression(image, options)
          const formData = new FormData()
          formData.append('file', compressedFile)
          formData.append(
            'dir',
            'alert-summary' + '/' + this.dataEdit.license_plate
          )

          const response = await REPO.updateFileHistory(
            formData,
            this.id + 'attach_' + index
          )
          return response.data.data.url
        })

        const uploadedUrls = await Promise.all(uploadPromises)
        dataForm.attachment = uploadedUrls

        await REPO.updateAlertSummary(
          dataForm,
          param.vehicle_id,
          param.event_type
        )
        // this.loadingBtnStop('btn-submit')
        this.$emit('submitModal', false)
        this.successUpload()
        this.closeForm()
        this.$root.$emit('reloadNotifAtas')
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>
<style>
.vs-popup {
  width: auto !important;
}

.img-upload {
  margin-left: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

sup {
  color: red;
}

.fileUpload {
  background: transparent;
  color: #333333;
  font-size: 1em;
  overflow: hidden;
  padding: 0.875em; /*14px/16px*/
  position: relative;
  text-align: center;
  width: fit-content;
  cursor: pointer;
  border: 1px solid var(--Gray-4, #bdbdbd);
}
.fileUpload:hover,
.fileUpload:active,
.fileUpload:focus {
  background: transparent;
  cursor: pointer;
}
.fileUpload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  width: 148px;
  height: 46px;
  cursor: pointer;
}

input[type='file'] {
  position: fixed;
  right: 100%;
  bottom: 100%;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
</style>
